import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import Payslip from './Payslip';
import PayslipsList from './Payslips';
import PayslipPDF from './PayslipPDF';
import TwoColumn from '../../components/TwoColumn';

export default function Payslips() {
  const location = useLocation();

  const active = React.useMemo(() => (location.pathname !== '/payslips'), [location]);

  return (
    <TwoColumn right={active}>
      <TwoColumn.Left>
        <PayslipsList />
      </TwoColumn.Left>
      <TwoColumn.Right>
        <Routes>
          <Route path=":id" element={<Payslip />} />
          <Route path=":id/pdf" element={<PayslipPDF />} />
        </Routes>
      </TwoColumn.Right>
    </TwoColumn>
  );
}
